import { Box, Flex, Heading, Button } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

function Navbar() {
  return (
    <Box bg="blue.500" px={4} py={4}>
      <Flex maxW="1200px" mx="auto" justify="space-between" align="center">
        <Heading as={RouterLink} to="/" size="md" color="white">
          AI Tutor
        </Heading>
        <Button as={RouterLink} to="/" variant="ghost" color="white">
          Home
        </Button>
      </Flex>
    </Box>
  );
}

export default Navbar; 